import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading = false;
  hidePassword = true;
  loginError: string | null = null;
  isDarkMode = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private notificationService: ToastrService,
    private authService: AuthService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      rememberMe: [false]
    });

    // Verificar si hay un tema guardado en localStorage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      this.isDarkMode = true;
    }

    // Redirigir si ya está autenticado
    this.authService.isLoggedIn().pipe(take(1)).subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.router.navigate(['/main']);
      }
    });
  }

  ngOnInit(): void {
    // Verificar si hay credenciales guardadas
    this.authService.getStoredEmail().then(savedEmail => {
      if (savedEmail) {
        this.loginForm.patchValue({
          email: savedEmail,
          rememberMe: true
        });
      }
    });
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.loginError = null;

      const { email, password, rememberMe } = this.loginForm.value;

      this.authService.login(email, password, rememberMe).subscribe({
        next: () => {
          this.isLoading = false;
          this.notificationService.success('Inicio de sesión exitoso');

          // Verificar nuevamente la autenticación antes de redirigir
          this.authService.isLoggedIn().pipe(take(1)).subscribe(isLoggedIn => {
            if (isLoggedIn) {
              this.router.navigate(['/main']).then(navigated => {
                if (!navigated) {
                  console.error('Error en la navegación a /main');
                  this.notificationService.error('Error al redirigir a la página principal');
                }
              });
            } else {
              this.notificationService.error('Error en la autenticación');
            }
          });
        },
        error: (error) => {
          this.isLoading = false;
          this.loginError = this.getErrorMessage(error);
          this.notificationService.error(this.loginError);
          console.error('Error en login:', error);
        }
      });
    } else {
      this.markFormGroupTouched(this.loginForm);
    }
  }

  private getErrorMessage(error: any): string {
    if (error.status === 401) {
      return 'Credenciales incorrectas. Por favor, verifica tu email y contraseña.';
    } else if (error.status === 0) {
      return 'No se pudo conectar con el servidor. Verifica tu conexión a internet.';
    } else {
      return 'Error al iniciar sesión. Por favor, inténtalo de nuevo más tarde.';
    }
  }

  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light');
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if ((control as FormGroup).controls) {
        this.markFormGroupTouched(control as FormGroup);
      }
    });
  }
}
